export default "/images/dashboard-active-dark.svg?0c1c8176e3cf5021d690f2c8cda3418d";